module.exports = __webpack_public_path__ + "d63bdd08ee31485254b3c2e4c971d21d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-2/icon_1-sec2.svg
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-2/icon_1-sec2.svg
// module chunks = 40